import { p as proxyCustomElement, H, c as createEvent, h, a as Host } from './index.js';
import { h as handleDismiss } from './p-CY_xCDya.js';
import { d as defineCustomElement$6 } from './p-CkgLRZPl.js';
import { d as defineCustomElement$5 } from './p-aAvJ0uEW.js';
import { d as defineCustomElement$4 } from './p-Birh0vlD.js';
import { d as defineCustomElement$3 } from './p-Bjt5CD4D.js';
import { d as defineCustomElement$2 } from './p-QtR5VUMp.js';

const infoboxCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:var(--jw-theme-surface-level1-default-bg-color);border:1px solid var(--jw-theme-surface-border-border-color);border-radius:.375rem;box-sizing:border-box;color:var(--jw-theme-surface-text-default-color);display:flex;flex-direction:column;font-family:Open Sans;font-size:.875rem;font-weight:400;gap:.75rem;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;padding:1rem .75rem}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host ::slotted(p){color:var(--jw-theme-surface-text-default-color)!important;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem}header{align-items:center;display:inline-flex;flex:1;justify-content:space-between}";

const WuiInfobox$1 = /*@__PURE__*/ proxyCustomElement(class WuiInfobox extends H {
    constructor(registerHost) {
        super();
        if (registerHost !== false) {
            this.__registerHost();
        }
        this.__attachShadow();
        this.dismiss = createEvent(this, "dismiss", 3);
        //////// DISMISSIBLE START ////////
        this.dismissible = true;
        this.handleDismiss = () => handleDismiss(this);
        //////// DISMISSIBLE END ////////
        /**
         * Tag label
         */
        this.label = 'How to';
    }
    render() {
        return (h(Host, { key: 'f5f5eb93e891178adbd082c7b0b2b6b97d9c828c' }, (this.label || this.dismissible) && (h("header", { key: 'b8dc3a2b4f72d787c213faa4cb24ce8b3213f2c3' }, this.label && h("wui-tag", { key: '3594f9bad9942804e292f25be196cc10b0a70bba', label: this.label, icon: this.icon || 'bulb' }), this.dismissible && h("wui-close-button", { key: '9426e5acaf5ee3afb228fd8192ae29032d071cda', onClick: this.handleDismiss, tooltip: this.tooltip }))), h("slot", { key: '66fb48d3c918dde20f065bdccef0b24172f5caf8' })));
    }
    get elm() { return this; }
    static get style() { return infoboxCss; }
}, [257, "wui-infobox", {
        "dismissible": [4],
        "label": [1],
        "icon": [1],
        "tooltip": [1]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-infobox", "wui-close-button", "wui-icon", "wui-tag", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-infobox":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiInfobox$1);
            }
            break;
        case "wui-close-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-tag":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiInfobox = WuiInfobox$1;
const defineCustomElement = defineCustomElement$1;

export { WuiInfobox, defineCustomElement };
